module.exports = __webpack_public_path__ + "static/media/cb-cover.32ca57ea.png";